import pdfToText from 'react-pdftotext'
import '../Styles.css';
import { jwtDecode } from "jwt-decode";
import { Middleware, MiddlewareProvider } from './Middleware';
import axios from 'axios';
import React from 'react';
import { TokenValidateExpiration } from './Token';

const token = localStorage.getItem("token");
var decode = "";
var email = "";
var rfc = "";
var user = "";
var role = 0;

if (token) {
    decode = jwtDecode(token);
    rfc = decode.rfc;
    email = decode.email;
    role = decode.role;
}

if (rfc.length == 13) {
    var person = 1;
} else {
    var person = 2;
}

if (role == 1 || role == 2) {
    user = email;
} else {
    user = "No definido";
}

if (role == 3) {
    user = rfc;
} else {
    user = "No definido";
}

function ProviderDocumentView(id) {
    axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/admin/provider/document/read/' + id +'/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        let pdfWindow = window.open("")
        pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
            encodeURI(response.data.message) + "'></iframe>"
        )
    });
}

function ProviderChargeDocuments(event){
    document.getElementById("messageError").style.display = "none";
    document.getElementById("messageError").innerHTML = "";
    document.getElementById("form").style.display = "none";
    document.getElementById("ChgB").style.display = "block";

    
    var tipoDocumento = document.getElementById("typeDocument").value;
    var idUser = decode.id;
    var rfc = decode.rfc;

    var file = document.getElementById("file").files[0];

    var CSF;
    var RFC;

    if (file.type != "application/pdf") {
        document.getElementById("form").style.display = "block";
        document.getElementById("typeDocument").value = "";
        document.getElementById("file").value = "";
        document.getElementById("messageError").style.display = "block";
        document.getElementById("messageError").innerHTML = "Sólo se permiten archivos con extensión .pdf";
        document.getElementById("ChgB").style.display = "none";
        return;
    }

    if (tipoDocumento == "") {
        document.getElementById("form").style.display = "block";
        document.getElementById("typeDocument").value = "";
        document.getElementById("file").value = "";
        document.getElementById("messageError").style.display = "block";
        document.getElementById("messageError").innerHTML = "No se seleccionó un tipo de documento";
        document.getElementById("ChgB").style.display = "none";
        return;
    }

    if (tipoDocumento == "001") {
        pdfToText(file)
            .then(text => {
                const pdfText = text;

                CSF = pdfText.includes("CÉDULA DE IDENTIFICACIÓN FISCAL");
                RFC = pdfText.includes(rfc);

                if (CSF == false) {
                    document.getElementById("form").style.display = "block";
                    document.getElementById("typeDocument").value = "";
                    document.getElementById("file").value = "";
                    document.getElementById("messageError").style.display = "block";
                    document.getElementById("messageError").innerHTML = "Constancia de situación fiscal inválida";
                    document.getElementById("ChgB").style.display = "none";
                    return;
                }

                if (RFC == false) {
                    document.getElementById("form").style.display = "block";
                    document.getElementById("typeDocument").value = "";
                    document.getElementById("file").value = "";
                    document.getElementById("messageError").style.display = "block";
                    document.getElementById("messageError").innerHTML = "El RFC del proveedor no coincide con la constancia";
                    document.getElementById("ChgB").style.display = "none";
                    return;
                }

                var IdCIF = "";
                var RazonSocial = "";
                var RegimenCapital = "";
                var Regimen = "";
                var NombreComercial = "";
                var FechaInicioOperaciones = "";
                var EstatusPadron = "";
                var FechaUltimoCambioEstado = "";
                var RegimenFiscal = "";
                var ActividadEconomica = "";
                var DireccionConstanciaFiscal = "";
                var CURP = "";
                var Nombres = "";
                var PrimerApellido = "";
                var SegundoApellido = "";
                var OrigenContribuyente = "";
                var TipoContribuyenteVal = "";

                if (person == 2) {
                     //Get id CIF
                    var initChain = "idCIF:";
                    var endChain = "VALIDA TU INFORMACIÓN";

                    var posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    var posicionFinal = pdfText.indexOf(endChain);

                    IdCIF = pdfText.substring(posicionInicio, posicionFinal).trim();

                    //Get Razón Social
                    initChain = "Denominación/Razón Social:";
                    endChain = "Régimen Capital:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    RazonSocial = pdfText.substring(posicionInicio, posicionFinal).trim();

                    //Get Régimen Capital
                    initChain = "Régimen Capital:";
                    endChain = "Nombre Comercial:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    RegimenCapital = pdfText.substring(posicionInicio, posicionFinal).trim();

                    //Get Nombre Comercial
                    initChain = "Nombre Comercial:";
                    endChain = "Fecha inicio de operaciones:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    NombreComercial = pdfText.substring(posicionInicio, posicionFinal).trim();

                    //Fecha de Inicio de Operaciones
                    initChain = "Fecha inicio de operaciones:";
                    endChain = "Estatus en el padrón:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    FechaInicioOperaciones = pdfText.substring(posicionInicio, posicionFinal).trim();

                    //Get Estatus Padron
                    initChain = "Estatus en el padrón:";
                    endChain = "Fecha de último cambio de estado:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    EstatusPadron = pdfText.substring(posicionInicio, posicionFinal).trim();

                    //Get fecha de ultimo cambio de estado
                    initChain = "Fecha de último cambio de estado:";
                    endChain = "Datos del domicilio registrado";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    FechaUltimoCambioEstado = pdfText.substring(posicionInicio, posicionFinal).trim();

                    //Get regimen fiscal //Regimen
                    initChain = "Régimen   Fecha Inicio   Fecha Fin";
                    endChain = "Obligaciones:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var RF = pdfText.substring(posicionInicio, posicionFinal).trim();

                    RF = RF.slice(0, -10);

                    RegimenFiscal = RF.trim();

                    Regimen = RegimenFiscal

                    //Get actividad económica
                    initChain = "Orden   Actividad Económica   Porcentaje   Fecha Inicio   Fecha Fin";
                    endChain = "Regímenes: Régimen";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var AE = pdfText.substring(posicionInicio, posicionFinal).trim();

                    AE = AE.replaceAll("/", "");

                    AE = AE.replace(/[0-9]/g, "");

                    ActividadEconomica = AE.trim();

                    initChain = "Tipo de Vialidad: ";
                    endChain = "Nombre de Vialidad:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP1 = pdfText.substring(posicionInicio, posicionFinal).trim();
                    
                    initChain = "Nombre de Vialidad: ";
                    endChain = "Número Exterior:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP2 = pdfText.substring(posicionInicio, posicionFinal).trim();


                    initChain = "Número Exterior: ";
                    endChain = "Número Interior:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP3 = pdfText.substring(posicionInicio, posicionFinal).trim();


                    initChain = "Número Interior: ";
                    endChain = "Nombre de la Colonia:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP4 = pdfText.substring(posicionInicio, posicionFinal).trim();


                    initChain = "Nombre de la Colonia:";
                    endChain = "Nombre de la Localidad:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP5 = pdfText.substring(posicionInicio, posicionFinal).trim();


                    initChain = "Nombre de la Localidad:";
                    endChain = "Nombre del Municipio o Demarcación Territorial:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP6 = pdfText.substring(posicionInicio, posicionFinal).trim();


                    initChain = "Nombre del Municipio o Demarcación Territorial:";
                    endChain = "Nombre de la Entidad Federativa:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP7 = pdfText.substring(posicionInicio, posicionFinal).trim();


                    initChain = "Nombre de la Entidad Federativa:";
                    endChain = "Entre Calle:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP8 = pdfText.substring(posicionInicio, posicionFinal).trim();

                    DireccionConstanciaFiscal = DireccionConstanciaFiscalP1+" "+DireccionConstanciaFiscalP2+" NÚMERO "+DireccionConstanciaFiscalP3+" INTERIOR "+DireccionConstanciaFiscalP4+" COLONIA "+DireccionConstanciaFiscalP5+", "+DireccionConstanciaFiscalP6+", "+DireccionConstanciaFiscalP7+", "+DireccionConstanciaFiscalP8;

                    OrigenContribuyente = "002";
                    
                    TipoContribuyenteVal = "002";

                    CURP = "";

                    Nombres = "";

                    PrimerApellido = "";

                    SegundoApellido = "";
                }

                if (person == 1) {
                    OrigenContribuyente = "001";

                    //Get id CIF
                    var initChain = "idCIF:";
                    var endChain = "VALIDA TU INFORMACIÓN";

                    var posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    var posicionFinal = pdfText.indexOf(endChain);

                    IdCIF = pdfText.substring(posicionInicio, posicionFinal).trim();

                    //Get CURP
                    var initChain = "CURP:";
                    var endChain = "Nombre (s):";

                    var posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    var posicionFinal = pdfText.indexOf(endChain);

                    CURP = pdfText.substring(posicionInicio, posicionFinal).trim();

                    //Get Nombre Comercial
                    initChain = "Registro Federal de Contribuyentes";
                    endChain = "Nombre, denominación o razón";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    NombreComercial = pdfText.substring(posicionInicio, posicionFinal).trim();

                    //Get Nombre (s)
                    initChain = "Nombre (s):";
                    endChain = "Primer Apellido:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    Nombres = pdfText.substring(posicionInicio, posicionFinal).trim();

                    //Get Primer Apellido
                    initChain = "Primer Apellido:";
                    endChain = "Segundo Apellido:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    PrimerApellido = pdfText.substring(posicionInicio, posicionFinal).trim();

                    //Get Segundo Apellido
                    initChain = "Segundo Apellido:";
                    endChain = "Fecha inicio de operaciones:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    SegundoApellido = pdfText.substring(posicionInicio, posicionFinal).trim();

                    TipoContribuyenteVal = "001";

                    //Get Dirección
                    initChain = "Tipo de Vialidad: ";
                    endChain = "Nombre de Vialidad:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP1 = pdfText.substring(posicionInicio, posicionFinal).trim();
                    
                    initChain = "Nombre de Vialidad: ";
                    endChain = "Número Exterior:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP2 = pdfText.substring(posicionInicio, posicionFinal).trim();


                    initChain = "Número Exterior: ";
                    endChain = "Número Interior:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP3 = pdfText.substring(posicionInicio, posicionFinal).trim();


                    initChain = "Número Interior: ";
                    endChain = "Nombre de la Colonia:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP4 = pdfText.substring(posicionInicio, posicionFinal).trim();


                    initChain = "Nombre de la Colonia:";
                    endChain = "Nombre de la Localidad:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP5 = pdfText.substring(posicionInicio, posicionFinal).trim();


                    initChain = "Nombre de la Localidad:";
                    endChain = "Nombre del Municipio o Demarcación Territorial:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP6 = pdfText.substring(posicionInicio, posicionFinal).trim();


                    initChain = "Nombre del Municipio o Demarcación Territorial:";
                    endChain = "Nombre de la Entidad Federativa:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP7 = pdfText.substring(posicionInicio, posicionFinal).trim();


                    initChain = "Nombre de la Entidad Federativa:";
                    endChain = "Entre Calle:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var DireccionConstanciaFiscalP8 = pdfText.substring(posicionInicio, posicionFinal).trim();

                    DireccionConstanciaFiscal = DireccionConstanciaFiscalP1+" "+DireccionConstanciaFiscalP2+" NÚMERO "+DireccionConstanciaFiscalP3+" INTERIOR "+DireccionConstanciaFiscalP4+" COLONIA "+DireccionConstanciaFiscalP5+", "+DireccionConstanciaFiscalP6+", "+DireccionConstanciaFiscalP7+", "+DireccionConstanciaFiscalP8;

                    //Get Régimen Capital
                    RegimenCapital = "SIN TIPO DE SOCIEDAD";

                    //Get Estatus Padron
                    initChain = "Estatus en el padrón:";
                    endChain = "Fecha de último cambio de estado:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    EstatusPadron = pdfText.substring(posicionInicio, posicionFinal).trim();

                    //Get regimen fiscal //Regimen
                    initChain = "Régimen   Fecha Inicio   Fecha Fin";

                    var found = pdfText.includes("Obligaciones:");
                    
                    //alert(found); // Output: true
                    
                    if (found) {
                        endChain = "Obligaciones:";
                    } else {
                        endChain = "Sus datos personales son incorporados y protegidos en los sistemas del SAT";
                    }
                    
                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var RF = pdfText.substring(posicionInicio, posicionFinal).trim();

                    RF = RF.slice(0, -10);

                    RegimenFiscal = RF.trim();

                    Regimen = RegimenFiscal

                    //Get actividad económica
                    initChain = "Orden   Actividad Económica   Porcentaje   Fecha Inicio   Fecha Fin";
                    endChain = "Regímenes: Régimen";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    var AE = pdfText.substring(posicionInicio, posicionFinal).trim();

                    AE = AE.replaceAll("/", "");

                    AE = AE.replace(/[0-9]/g, "");

                    ActividadEconomica = AE.trim();

                    //Fecha de Inicio de Operaciones
                    initChain = "Fecha inicio de operaciones:";
                    endChain = "Estatus en el padrón:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    FechaInicioOperaciones = pdfText.substring(posicionInicio, posicionFinal).trim();

                    //Get fecha de ultimo cambio de estado
                    initChain = "Fecha de último cambio de estado:";
                    endChain = "Nombre Comercial:";

                    posicionInicio = pdfText.indexOf(initChain) + initChain.length;
                    posicionFinal = pdfText.indexOf(endChain);

                    FechaUltimoCambioEstado = pdfText.substring(posicionInicio, posicionFinal).trim();
                }

                console.log(pdfText);
                
                //Validations

                //idCIF
                if (IdCIF == "") {
                    window.scrollTo(0, 0);
                    document.getElementById("form").style.display = "none";
                    document.getElementById("ChgB").style.display = "none";
                    document.getElementById("messageError").style.display = "block";
                    document.getElementById("messageError").innerHTML = "No se pudo recuperar el idCIF de la CSF, recargando la pagina, por favor espere...";
                    setTimeout(() => {
                        window.location.href = '/proveedor-documentos';
                    }, 3000);
                    return 0;
                }

                //rfc
                if (decode.rfc == "") {
                    window.scrollTo(0, 0);
                    document.getElementById("form").style.display = "none";
                    document.getElementById("ChgB").style.display = "none";
                    document.getElementById("messageError").style.display = "block";
                    document.getElementById("messageError").innerHTML = "No se pudo recuperar el rfc de la CSF, recargando la pagina, por favor espere...";
                    setTimeout(() => {
                        window.location.href = '/proveedor-documentos';
                    }, 3000);
                    return 0;
                }

                //razon social
                if (RazonSocial == "" && person == 2) {
                    window.scrollTo(0, 0);
                    document.getElementById("form").style.display = "none";
                    document.getElementById("ChgB").style.display = "none";
                    document.getElementById("messageError").style.display = "block";
                    document.getElementById("messageError").innerHTML = "No se pudo recuperar la razón social de la CSF, contactar al equipo de soporte, recargando la pagina, por favor espere...";
                    setTimeout(() => {
                        window.location.href = '/proveedor-documentos';
                    }, 3000);
                    return 0;
                }

                //nombre comercial
                if (person == 1 && NombreComercial == "") {
                    NombreComercial = Nombres+" "+PrimerApellido+" "+SegundoApellido;
                }

                if (person == 2 && NombreComercial == "") {
                    NombreComercial = RazonSocial;
                }

                //nombres
                if (Nombres == "") {
                    Nombres = "NO DISPONIBLE";
                }

                //primer apellido
                if (PrimerApellido == "") {
                    PrimerApellido = "NO DISPONIBLE";
                }

                //segundo apellido
                if (SegundoApellido == "") {
                    SegundoApellido = "NO DISPONIBLE";
                }

                //dirección
                if (DireccionConstanciaFiscal.indexOf("[") > -1 || DireccionConstanciaFiscal.indexOf('"') > -1 || DireccionConstanciaFiscal.indexOf("&") > -1 || DireccionConstanciaFiscal.indexOf(":") > -1) {
                    DireccionConstanciaFiscal = "Monte Pelvoux 215, Lomas de Chapultepec. Alcaldía Miguel Hidalgo, Ciudad de México. C.P. 11000, México";
                }

                if (DireccionConstanciaFiscal == "") {
                    DireccionConstanciaFiscal = "Monte Pelvoux 215, Lomas de Chapultepec. Alcaldía Miguel Hidalgo, Ciudad de México. C.P. 11000, México";
                }

                //regimen capital
                if (RegimenCapital == "") {
                    RegimenCapital = "SIN TIPO DE SOCIEDAD";
                }

                //estatus padron
                if (EstatusPadron == "") {
                    EstatusPadron = "ACTIVO";
                }

                //regimen fiscal
                if (RegimenFiscal == "") {
                    if (person == 1) {
                        RegimenFiscal = "NO DEFINIDO 1"
                    }

                    if (person == 2) {
                        RegimenFiscal = "NO DEFINIDO 2"
                    }
                }

                //actividad economica
                if (ActividadEconomica == "") {
                    ActividadEconomica = "NO DEFINIDA";
                }

                //regimen
                if (Regimen == "") {
                    if (person == 1) {
                        RegimenFiscal = "NO DEFINIDO 1"
                    }

                    if (person == 2) {
                        RegimenFiscal = "NO DEFINIDO 2"
                    }
                }

                //fecha inicio de operacioens
                if (FechaInicioOperaciones == "") {
                    FechaInicioOperaciones = "01/01/1900";
                }

                //fecha último cambio estatus
                if (FechaUltimoCambioEstado == "") {
                    FechaUltimoCambioEstado = "01/01/1900";
                }

                axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/general-data/load/'+token, {
                    OrigenContribuyente: OrigenContribuyente,
                    IdCIF: IdCIF,
                    RFC: decode.rfc,
                    CURP: CURP,
                    RazonSocial: RazonSocial,
                    NombreComercial: NombreComercial,
                    Nombres: Nombres,
                    PrimerApellido: PrimerApellido,
                    SegundoApellido: SegundoApellido,
                    TipoProveedor: "",
                    TipoContribuyente: TipoContribuyenteVal,
                    CategoriaAbastoSuministro: "",    
                    SubcategoriaAbastoSuministro: "", 
                    DireccionFiscal: DireccionConstanciaFiscal,
                    RegimenCapital: RegimenCapital,
                    EstatusPadron: EstatusPadron,
                    RegimenFiscal: RegimenFiscal,
                    ActividadEconomica: ActividadEconomica,
                    Regimen: Regimen,
                    FechaInicioOperaciones: FechaInicioOperaciones,       
                    FechaUltimoCambio: FechaUltimoCambioEstado,            
                    IdUser: decode.id,
                    }, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        }
                    }
                )
                .then(response => {
                    axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/documents/load/'+token, {
                    file,
                    TipoDocumento: tipoDocumento,
                    IdUser: idUser,
                    RFC: rfc,
                    }, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        }
                    }
                    )
                    .then(response => {
                        window.scrollTo(0, 0);
                        document.getElementById("form").style.display = "none";
                        document.getElementById("ChgB").style.display = "none";
                        document.getElementById("messageSuccess").style.display = "block";
                        document.getElementById("messageSuccess").innerHTML = "Archivo cargado exitosamente, recargando la pagina, por favor espere...";
                        setTimeout(() => {
                            window.location.href = '/proveedor-documentos';
                        }, 3000);
                    })
                    .catch(error => {
                        document.getElementById("form").style.display = "block";
                        document.getElementById("ChgB").style.display = "none";
                        document.getElementById("messageError").style.display = "block";
                        document.getElementById("messageError").innerHTML = "Error al cargar el archivo";
                        document.getElementById("typeDocument").value = "";
                        document.getElementById("file").value = "";
                        file = "";
                        return;
                    });
                    
                })
                .catch(error => {
                    document.getElementById("form").style.display = "block";
                    document.getElementById("ChgB").style.display = "none";
                    document.getElementById("messageError").style.display = "block";
                    document.getElementById("messageError").innerHTML = "Error al obtener los datos de la constancia";
                    document.getElementById("typeDocument").value = "";
                    document.getElementById("file").value = "";
                    file = "";
                    return;
                });
            })
            .catch(error => {
                document.getElementById("form").style.display = "block";
                document.getElementById("ChgB").style.display = "none";
                document.getElementById("messageError").style.display = "block";
                document.getElementById("messageError").innerHTML = "Error al leer el archivo";
                document.getElementById("typeDocument").value = "";
                document.getElementById("file").value = "";
                file = "";
                return;
            });
    } 
    if (tipoDocumento != "001") {
        axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/documents/load/'+token, {
                file,
                TipoDocumento: tipoDocumento,
                IdUser: idUser,
                RFC: rfc,
                }, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }
            ).then(response => {
                window.scrollTo(0, 0);
                document.getElementById("form").style.display = "none";
                document.getElementById("messageError").style.display = "none";
                document.getElementById("ChgB").style.display = "none";
                document.getElementById("messageSuccess").style.display = "block";
                document.getElementById("messageSuccess").innerHTML = "Archivo cargado exitosamente, recargando la pagina, por favor espere...";
                setTimeout(() => {
                    window.location.href = '/proveedor-documentos';
                }, 3000);
            })
            .catch(error => {
                document.getElementById("form").style.display = "block";
                document.getElementById("ChgB").style.display = "none";
                document.getElementById("messageError").style.display = "block";
                document.getElementById("messageError").innerHTML = "Error al cargar el archivo";
                document.getElementById("typeDocument").value = "";
                document.getElementById("file").value = "";
                file = "";
                return;
            });
    }
}

function ProviderRemoveDocuments(id) {
    if(window.confirm("¿Estás seguro de eliminar el archivo?") == false){
        return;
    }

    window.scrollTo(0, 0);
    document.getElementById("form").style.display = "none";
    document.getElementById("messageError").style.display = "none";
    document.getElementById("messageError").innerHTML = "";
    document.getElementById("ChgB").style.display = "block";

    axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/documents/delete/'+token, {
        IdDocument: id,
        IdUser: decode.id,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    ).then(response => {
        window.scrollTo(0, 0);
        document.getElementById("form").style.display = "none";
        document.getElementById("ChgB").style.display = "none";
        document.getElementById("messageSuccess").style.display = "block";
        document.getElementById("messageSuccess").innerHTML = "Archivo eliminado exitosamente, recargando la pagina, por favor espere...";
        setTimeout(() => {
            window.location.href = '/proveedor-documentos';
        }, 3000);
    })
    .catch(error => {
        console.log(error);
    });
}

function ProviderDocumentsFinish() {
    document.getElementById("messageError").innerHTML = "";

    document.getElementById("ChgA").style.display = "block";
    document.getElementById("BtnA").style.display = "none";
    
    //window.location.href = '/proveedor-datos-generales';

    if (person == 1) {
        if (
            document.getElementById("fileProvider1") &&
            document.getElementById("fileProvider4") &&
            document.getElementById("fileProvider6") && 
            document.getElementById("fileProvider10") &&
            document.getElementById("fileProvider11") &&
            document.getElementById("fileProvider21") 
        ) {
            window.location.href = '/proveedor-datos-generales';
        } else {
            window.scrollTo(0, 0);
            document.getElementById("messageError").style.display = "inline-block";
            document.getElementById("messageError").innerHTML = "Faltan documentos obligatorios por cargar";
            document.getElementById("ChgA").style.display = "none";
            document.getElementById("BtnA").style.display = "inline-block";
            return;
        }  
    } 
    
    if (person == 2) {
        if (
            document.getElementById("fileProvider1") &&
            document.getElementById("fileProvider4") &&
            document.getElementById("fileProvider6") && 
            document.getElementById("fileProvider10") &&
            document.getElementById("fileProvider11") &&
            document.getElementById("fileProvider19") &&
            document.getElementById("fileProvider20") &&
            document.getElementById("fileProvider21") 
        ) {
            window.location.href = '/proveedor-datos-generales';
        } else {
            window.scrollTo(0, 0);
            document.getElementById("messageError").style.display = "inline-block";
            document.getElementById("messageError").innerHTML = "Faltan documentos obligatorios por cargar";
            document.getElementById("ChgA").style.display = "none";
            document.getElementById("BtnA").style.display = "inline-block";
            return;
        }  
    }
}

function ProviderDocuments() {
    Middleware();
    MiddlewareProvider();

    const token = localStorage.getItem("token");
    TokenValidateExpiration(token);

    //Get documents
    const [documents, setDoduments] = React.useState([]);

    //Get documents provider
    const [providerDocuments, setProviderDocuments] = React.useState([]);

    //Get remain documents provider 
    const [providerDocumentsRemain, setProviderDocumentsRemain] = React.useState([]);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/documents/' + token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
            .then(response => {
                console.log(response);
                setDoduments(response.data);
            });
        }, []);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/documents/' + token + '/' + rfc, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        setProviderDocuments(response.data);
        if (response.data == null) {
            setProviderDocuments([]);
        }
    });
    }, []);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/documents-remain/' + token + '/' + rfc, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        setProviderDocumentsRemain(response.data);
        if (response.data == null) {
            setProviderDocumentsRemain([]);
        }
    })
    .catch(error => {
        console.log(error);
    });
    }, []);
    
    return (
        <div className='Container'>
            <div className='Navbar'>
                <div>
                    <h5 className='text-white'>Portal de proveedores</h5>
                </div>
            </div>
            <div className='Section'>
                <div className='Header'>
                    <div className="text-center">
                        <div className='row'>
                            <div className='col-md-6 Text-left'>
                                <label className='mt-1 Text-Gray'><b>Usuario: </b>
                                    {  
                                        user
                                    }
                                </label>
                            </div>
                            <div className='col-md-6 Text-right'>
                                <a href='/logout'>
                                    <label>
                                        Cerrar sesión
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fillRule="currentColor" className="bi bi-box-arrow-right m-1" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z" />
                                            <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z" />
                                        </svg>
                                    </label>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='Article'>
                    <div className="text-center">
                        <h1 className='Text-Red'>Documentos</h1>
                        <br></br>
                        <label className='text-gray'>
                            Los documentos en la lista que empiezan con un asterísco (*) son obligatiorios, por lo que se requiere que todos sean cargados para continuar con el proceso de registro.
                        </label>
                        <br></br>
                        <br></br>
                        <p><i id="ChgB" className="fa fa-spinner fa-spin Chg"></i></p>
                        <div className='d-flex justify-content-center'>
                            <label id='messageError' className='Error-Notification'></label>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <label id='messageSuccess' className='Success-Notification'></label>
                        </div>
                        <br></br>
                        <form id='form' action={ProviderChargeDocuments}>
                            <select id="typeDocument" className='w-50 Select-Style' required>
                                <option value="">Selecciona el tipo de documento a cargar</option>
                                {
                                    person == 1
                                    &&
                                    providerDocumentsRemain.map(item => (
                                        item.fisicNational == true && item.fisicNationalObligatorio == true
                                        && 
                                        <option id={"fileSelect"+item.id} key={"fileSelect"+item.id} value={item.code}>* {item.name}</option>
                                    ))
                                }
                                {
                                    person == 1
                                    &&
                                    providerDocumentsRemain.map(item => (
                                        item.fisicNational == true && item.fisicNationalObligatorio != true
                                        && 
                                        <option id={"fileSelect"+item.id} key={"fileSelect"+item.id} value={item.code}>{item.name}</option>
                                    ))
                                }
                                {
                                    person == 2
                                    &&
                                    providerDocumentsRemain.map(item => (
                                        item.moralNational == true && item.moralNationalObligatorio == true
                                        && 
                                        <option id={"fileSelect"+item.id} key={"fileSelect"+item.id} value={item.code}>* {item.name}</option>
                                    ))
                                }
                                {
                                    person == 2
                                    &&
                                    providerDocumentsRemain.map(item => (
                                        item.moralNational == true && item.moralNationalObligatorio != true
                                        && 
                                        <option id={"fileSelect"+item.id} key={"fileSelect"+item.id} value={item.code}>{item.name}</option>
                                    ))
                                }
                            </select>
                            <br></br>
                            <br></br>
                            <input id='file' name='file' type="file" accept="application/pdf" required />
                            <br></br>
                            <br></br>
                            <input type='submit' className='Button-Style' value="Cargar"></input>
                        </form>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        {
                            providerDocuments != ""
                            &&
                            <div>
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th scope="col" className='Text-left'>Nombre</th>
                                            <th scope='col' className='Text-left'>Documento</th>
                                            <th scope='col'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            providerDocuments
                                            &&
                                            providerDocuments.map(item => (
                                                <tr id={"fileProvider"+item.tipoDocumento} key={item.tipoDocumento} value={"fileProvider"+item.tipoDocumento}>
                                                    <td  className='Text-left'>
                                                        {
                                                            documents.map(docs => (
                                                                item.tipoDocumento == docs.code
                                                                &&
                                                                <label>{docs.name}</label>
                                                            ))
                                                        }
                                                    </td>
                                                    <td  className='Text-left'>{item.documento}</td>
                                                    <td>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fillRule="currentColor" className="bi bi-filetype-pdf" viewBox="0 0 16 16" onClick={() => ProviderDocumentView(item.id)}>
                                                            <path fillRule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"/>
                                                        </svg>
                                                        &nbsp;
                                                        &nbsp;
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16" onClick={() => ProviderRemoveDocuments(item.id)}>
                                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                                                        </svg>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                                <i id="ChgA"className="fa fa-spinner fa-spin Chg"></i>
                                <input id='BtnA' type='submit' value='Continuar' className='Button-Style' onClick={ProviderDocumentsFinish}></input>
                                <br></br>
                                <br></br>
                            </div>
                        } 
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProviderDocuments;